import { FC } from 'react'
import Cookies from 'js-cookie'
import { cn } from '@/libs/utils'
import { Search } from 'lucide-react'
import { SearchProvider } from '@/context/search-context'
import { SidebarProvider } from '@/components/ui/sidebar'
import { AdminAppSidebar } from '@/components/admin/admin-app-sidebar'
import { AdminProtectedRoute } from '@/components/auth/admin-protected-route'
import { Header } from '@/components/layout/header'
import { ProfileDropdown } from '@/components/profile-dropdown'
import { ThemeSwitch } from '@/components/theme-switch'

interface AdminLayoutProps {
  children?: React.ReactNode
}

const AdminLayout: FC<AdminLayoutProps> = ({ children }) => {
  const defaultOpen = Cookies.get('sidebar:state') !== 'false'

  return (
    <AdminProtectedRoute>
      <SearchProvider>
        <SidebarProvider defaultOpen={defaultOpen}>
          {/* <SkipToMain /> */}
          <AdminAppSidebar />
          <div
            id='content'
            className={cn(
              'ml-auto w-full max-w-full',
              'peer-data-[state=collapsed]:w-[calc(100%-var(--sidebar-width-icon)-1rem)]',
              'peer-data-[state=expanded]:w-[calc(100%-var(--sidebar-width))]',
              'transition-[width] duration-200 ease-linear',
              'flex h-svh flex-col',
              'group-data-[scroll-locked=1]/body:h-full',
              'group-data-[scroll-locked=1]/body:has-[main.fixed-main]:h-svh'
            )}
          >
            <Header>
              <Search />

              <div className='ml-auto flex items-center space-x-4'>
                <ThemeSwitch />
                <ProfileDropdown />
              </div>
            </Header>
            {children}
          </div>
        </SidebarProvider>
      </SearchProvider>
    </AdminProtectedRoute>
  )
}

export default AdminLayout
